import type {ReactElement} from 'react';
import {AddAccountIcon} from '@Components/social-media/components/add-account-icon';
import {noop} from '@Utils/general.util';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize, IconType} from '@Components/icon-v2/icon.types';
import {getAssetUrl} from '@Utils/s3.util';
import {ClickableDiv} from '@Components/clickable-div';
import {getSocialAccountsUpsellByPremiumLevel, showSocialMediaPublishingUpsellDialog} from '@Libraries/social-media-account.library';
import {getUserPremiumLevel} from '@Libraries/user.library';
import styles from './more-accounts-upsell.module.scss';

export function MoreAccountsUpsell(): ReactElement<any> | null {
  return (
    <ClickableDiv
      className={`flex-h-row flex-items-start ${styles.container}`}
      onClick={() => {
        showSocialMediaPublishingUpsellDialog(getSocialAccountsUpsellByPremiumLevel(), getUserPremiumLevel());
      }}
    >
      <div className="flex-h-row flex-align-items-center">
        <img className={`${styles.image} ${styles.firstImage}`} src={getAssetUrl('premium-upsell-add-accounts-image-1.png')} alt="" aria-hidden />
        <img className={`${styles.image} ${styles.secondImage}`} src={getAssetUrl('premium-upsell-add-accounts-image-2.png')} alt="" aria-hidden />
        <AddAccountIcon className={`${styles.image} ${styles.thirdImage}`} onClick={noop} />
      </div>
      <div className={`flex-vertical-center ${styles.verticalSeparator}`} />
      <div className="flex-h-row flex-vertical-center">
        <Icon icon="icon-crown" className="spacing-m-r-2 flex-vertical-center color-premium" type={IconType.PREMIUM} size={IconSize.SIZE_ICON_16} />
        <Text size={TextSize.XSMALL} val={window.i18next.t('pmwjs_add_more_accounts')} className={styles.text} />
      </div>
    </ClickableDiv>
  );
}
